import React, { useState } from "react";
import { useBanner } from "../../../../providers/BannerProviders";
import useFetch from "../../../../hooks/useFetch";
import { faqList } from "../../../../services/faqService";
import Image from "../../../elements/Image";
// import Button from "../../../form/Button";
// import SectionTable from "./SectionTable";
// import Modal from "../../../elements/Modal";
// import EligibilityQuizContent from "../../../modalcontent/EligibilityQuizContent";
// import ApplicationDetails from "../../../modalcontent/ApplicationDetails";
// import { scholarshipList } from "../../../../services/scholarshipService";
// import dayjs from "dayjs";
// import { checkDateStatus } from "../../../../helpers";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";

const Eligibility = () => {
  // const [isApply, setApply] = useState({ isOpen: false, data: null });
  // const [isViewDetails, setViewDetails] = useState({
  //   isOpen: false,
  //   data: null,
  // });

  const { data } = useBanner();
  const applyBanner = data?.data?.find((item) => item?.bannerType === "apply");

  const {
    data: eligibilityData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-eligibility"],
    fetchFunction: async () => {
      const res = await faqList({
        categoryType: "eligibility",
        type: "general",
        sortQuery: "ordering",
        status: 1,
      });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          criteria: (res?.docs?.data || [])?.map((item, i) => ({
            name: item?.title,
            ...item,
          })),
        };
      } else {
        return {};
      }
    },
  });

  // const { data: timelineData, isLoading: timelineLoading } = useFetch({
  //   dependencies: ["font-scholarship-timeline", session],
  //   fetchFunction: async () => {
  //     const res = await scholarshipList({ status: 1 });

  //     return {
  //       tableData: [
  //         {
  //           _id: 1,
  //           title: "Available Scholarships",
  //           subdata: res?.docs?.data?.map((item) => {
  //             return {
  //               ...item,
  //               date: item?.publishEndDate
  //                 ? dayjs(item?.publishEndDate).format("MMMM DD, YYYY")
  //                 : "-",
  //               viewAction: {
  //                 label: "View Details",
  //                 isLink: false,
  //                 onClick: () => setViewDetails({ isOpen: true, data: item }),
  //               },
  //               applyAction: {
  //                 isLink: false,
  //                 ...(checkDateStatus(item?.publishEndDate) !== "past"
  //                   ? {
  //                       label: "Apply",
  //                       onClick: () => setApply({ isOpen: true, data: item }),
  //                     }
  //                   : { label: "Currently Unavailable" }),
  //               },
  //             };
  //           }),
  //         },
  //       ],
  //     };
  //   },
  //   enabled: session?.status !== "loading",
  // });

  return (
    <>
      <div className="space-y-10">
        <div className="relative text-center space-y-6 max-w-none md:max-w-6xl mx-auto">
          {applyBanner?.details?.eligibility?.title && (
            <h2 className="text-2xl font-semibold">
              {applyBanner?.details?.eligibility?.title}
            </h2>
          )}
          {applyBanner?.details?.eligibility?.description && (
            <div
              className="text-base xls:text-lg xls:font-medium font-Gotham"
              dangerouslySetInnerHTML={{
                __html: applyBanner?.details?.eligibility?.description,
              }}
            />
          )}
        </div>
        {eligibilityData?.criteria?.length > 0 && (
          <div className="px-4">
            {eligibilityData?.criteria?.map((item, index) => (
              <div
                key={index}
                className="block md:flex bg-shades-03 group hover:bg-chestnut-rose transition-all duration-200"
              >
                <div className="flex items-left md:items-center justify-left md:justify-center w-full md:w-48 md:aspect-square flex-shrink-0 py-7 px-11 md:py-0 md:px-0">
                  <div className="font-CanelaDeck text-5xl xls:text-7xl font-semibold transition-all duration-200 group-hover:text-white">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                </div>
                <div className="space-y-4 flex-shrink flex-grow py-4 px-12 border-l border-white flex flex-col justify-center">
                  <h2
                    className="text-lg md:text-2xl font-semibold text-chestnut-rose transition-all duration-200 group-hover:text-white"
                    dangerouslySetInnerHTML={{ __html: item?.name }}
                  />

                  <div
                    className="text-lg font-Gotham font-medium transition-all duration-200 group-hover:text-white"
                    dangerouslySetInnerHTML={{
                      __html: item?.description,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="relative text-center space-y-6 max-w-6xl mx-auto">
        {applyBanner?.details?.eligibility?.subtitle && (
          <div
            className="text-base xls:text-lg xls:font-medium font-Gotham mt-8"
            dangerouslySetInnerHTML={{
              __html: applyBanner?.details?.eligibility?.subtitle,
            }}
          />
        )}
      </div>
      {applyBanner?.details?.eligibility?.eligibilityImage?.url && (
        <div className="w-full md:w-[480px] rounded-full overflow-hidden mx-auto relative text-center pt-10 max-w-6xl">
          <Image
            src={applyBanner?.details?.eligibility?.eligibilityImage?.url}
            effect={"fade"}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      {/* {timelineData?.tableData?.length > 0 && (
            <div className="">
              {timelineData?.tableData?.map((item, index) => (
                <SectionTable key={index} data={item} />
              ))}
            </div>
          )} */}

      {/* <div className="flex justify-center">
            <Button
              buttonLabel={"Apply Now"}
              buttonClasses={"!h-12 xls:!h-14 !rounded-full !px-6 xls:!px-10"}
              buttonHasLink={""}
              buttonFunction={() => {}}
              buttonLabelClasses={"text-base xls:!text-lg"}
            />
          </div> */}
      {/* <Modal
        isOpen={isApply?.isOpen}
        setIsOpen={() => setApply({ isOpen: false, data: null })}
        title={"Eligibility Quiz"}
        size="lg"
      >
        <EligibilityQuizContent
          data={isApply?.data}
          okHandler={() => setApply({ isOpen: false, data: null })}
        />
      </Modal>
      <Modal
        isOpen={isViewDetails?.isOpen}
        setIsOpen={() => setViewDetails({ isOpen: false, data: null })}
        title={isViewDetails?.data?.title || ""}
        size="xl5"
      >
        <ApplicationDetails
          data={isViewDetails?.data}
          onApply={(data) => {
            setApply({ isOpen: true, data: data });
            setViewDetails({ isOpen: false, data: null });
          }}
        />
      </Modal> */}
    </>
  );
};

export default Eligibility;
